<template>
  <div id="app">
    <router-view></router-view>
    <land></land>
  </div>
</template>

<script>
import land from "./components/land/land";
export default {
  name: "app",
  components: { land },
  data() {
    return {
      token: localStorage.getItem("token")
    };
  }
};
</script>

<style>
@import "../common.css";
</style>



// WEBPACK FOOTER //
// App.vue?4edd534c